import React from 'react'
import OurAppBanner from './OurAppBanner/OurAppBanner'
import VehicleSignal from './VehicleSignal/VehicleSignal'
import OurFeatures from './OurFeatures/OurFeatures'
import TheSolution from './TheSolution/TheSolution'

const OurApp = () => {
  return (
    <>
    <OurAppBanner/>
    <VehicleSignal/>
    <OurFeatures/>
    <TheSolution/>
    </>
  )
}

export default OurApp